const maxWidth = 800;
const maxHeight = 800;

/**
 * Convert a base64 to a file
 * @param base64String
 * @param filename
 * @returns
 */
export const base64ToFile = (base64String: string, filename?: string) => {
  const arr = base64String.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename || `screenshot-${Date.now()}.png`, { type: mime });
};

/**
 * Get the thumbnail of an image
 */
export const getImageThumbnailFile = async (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target?.result as string;
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject('get context fail');
        return;
      }

      // Calculate the compressed width and height, keeping the original proportions
      let width = img.width;
      let height = img.height;
      if (width > height) {
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      const compressedBase64 = canvas.toDataURL('image/jpeg', 0.8); // 使用 'image/jpeg' 格式并压缩质量（0.8）
      const compressedFile = base64ToFile(compressedBase64, file.name);

      resolve(compressedFile);
    };
  });
};

/**
 * get image dimensions
 * @param file
 * @returns
 */
export const getImageDimensions = (file: File): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (e: any) {
      const img = new Image();
      img.onload = function () {
        resolve({ width: img.width, height: img.height });
      };
      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  });
};
